/**
 * An enum containing the types of vehicle numbers the user can use to identify their vehicle.
 * @enum {number}
 */
 export default Object.freeze({
    /** A Vehicle Identification Number */
    VIN: "vin",
    /** An engine code number */
    ENGINE_CODE: "engine"
});